import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const InvoicesService = Services.invoices;
const InvoicesTypes = VuexTypes.invoices;
export default {
  [InvoicesTypes.INVOICES_LIST]: ({ commit, state }, params) => {
    state.invoicesList['status'] = statuses.LOADING;
    InvoicesService.list(params).then((data) => {
      commit(InvoicesTypes.INVOICES_LIST, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICES_LIST, errResponse);
    });
  },
  [InvoicesTypes.INVOICES_LIST_FILTERS]: ({ commit, state }) => {
    state.invoicesListFilters['status'] = statuses.LOADING;
    InvoicesService.listFilters().then((data) => {
      commit(InvoicesTypes.INVOICES_LIST_FILTERS, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICES_LIST_FILTERS, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_CLASSIFIERS]: ({ commit, state }) => {
    state.invoiceClassifiers['status'] = statuses.LOADING;
    InvoicesService.classifiers().then((data) => {
      commit(InvoicesTypes.INVOICE_CLASSIFIERS, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_CLASSIFIERS, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_CREATE_DATA]: ({ commit, state }) => {
    state.invoiceCreateData['status'] = statuses.LOADING;
    InvoicesService.createData().then((data) => {
      commit(InvoicesTypes.INVOICE_CREATE_DATA, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_CREATE_DATA, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_UPDATE_DATA]: ({ commit, state }, invoiceId) => {
    state.invoiceUpdateData['status'] = statuses.LOADING;
    InvoicesService.editData(invoiceId).then((data) => {
      commit(InvoicesTypes.INVOICE_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_UPDATE_DATA, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_MEDIA_LIST]: ({ commit, state }, invoiceId) => {
    state.invoiceMediaList['status'] = statuses.LOADING;
    InvoicesService.mediaList(invoiceId).then((data) => {
      commit(InvoicesTypes.INVOICE_MEDIA_LIST, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_MEDIA_LIST, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_CREATE]: ({ commit, state }, createData) => {
    state.invoiceCreate['status'] = statuses.LOADING;
    InvoicesService.create(createData).then((data) => {
      commit(InvoicesTypes.INVOICE_CREATE, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_CREATE, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_UPDATE]: ({ commit, state }, { id, update }) => {
    state.invoiceUpdate['status'] = statuses.LOADING;
    InvoicesService.update(id, update).then((data) => {
      commit(InvoicesTypes.INVOICE_UPDATE, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_UPDATE, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_DELETE_ATTACHMENT]: ({ commit, state }, { invoiceId, attachmentId }) => {
    state.invoiceDeleteAttachment['status'] = statuses.LOADING;
    InvoicesService.deleteAttachment(invoiceId, attachmentId).then((data) => {
      commit(InvoicesTypes.INVOICE_DELETE_ATTACHMENT, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_DELETE_ATTACHMENT, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_ITEMS_LIST]: ({ commit, state }, invoiceId) => {
    state.invoiceItemsList['status'] = statuses.LOADING;
    InvoicesService.itemsList(invoiceId).then((data) => {
      commit(InvoicesTypes.INVOICE_ITEMS_LIST, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_ITEMS_LIST, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_ITEMS_UPDATE]: ({ commit, state }, { invoiceId, itemId, updateData }) => {
    state.invoiceItemsUpdate['status'] = statuses.LOADING;
    InvoicesService.itemsUpdate(invoiceId, itemId, updateData).then((data) => {
      commit(InvoicesTypes.INVOICE_ITEMS_UPDATE, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_ITEMS_UPDATE, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_UPDATE_DETAINED_PAYMENT]: ({ commit, state }, { invoiceId, updateData }) => {
    state.invoiceUpdateDetainedPayment['status'] = statuses.LOADING;
    InvoicesService.detainedPayment(invoiceId, updateData).then((data) => {
      commit(InvoicesTypes.INVOICE_UPDATE_DETAINED_PAYMENT, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_UPDATE_DETAINED_PAYMENT, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_PAYMENT_APPROVE]: ({ commit, state }, { invoiceId, approvalData }) => {
    state.invoicePaymentApprove['status'] = statuses.LOADING;
    InvoicesService.approvePayment(invoiceId, approvalData).then((data) => {
      commit(InvoicesTypes.INVOICE_PAYMENT_APPROVE, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_PAYMENT_APPROVE, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_PAYMENT_REJECT]: ({ commit, state }, { invoiceId, rejectData }) => {
    state.invoicePaymentReject['status'] = statuses.LOADING;
    InvoicesService.rejectPayment(invoiceId, rejectData).then((data) => {
      commit(InvoicesTypes.INVOICE_PAYMENT_REJECT, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_PAYMENT_REJECT, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_ACTIVITY]: ({ commit, state }, { id, page }) => {
    state.invoiceActivity['status'] = statuses.LOADING;
    InvoicesService.activity(id, page).then((data) => {
      commit(InvoicesTypes.INVOICE_ACTIVITY, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_ACTIVITY, errResponse);
    });
  },
  [InvoicesTypes.INVOICE_DELETE]: ({ commit, state }, invoiceId) => {
    state.invoiceDelete['status'] = statuses.LOADING;
    InvoicesService.delete(invoiceId).then((data) => {
      commit(InvoicesTypes.INVOICE_DELETE, data);
    }).catch((errResponse) => {
      commit(InvoicesTypes.INVOICE_DELETE, errResponse);
    });
  },
};
